/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamConsentRecord } from './oralExamConsentRecord';

export type OralExamRunStateResponseConsentRecord = OralExamConsentRecord | null;
